import React,{ createContext,useContext,useReducer,useState } from "react";
import { storeReducer,productReducer } from "./Store/Reducer";

const GlobalData=createContext();

const Context=({children})=>{
    const [clickedId,setClickedId]=useState("");
    const [sorted,setSorted]=useState([]);
    const [allData,setAllData]=useState({});
    const [textSearch,settextSearch]=useState("");
    const [state,dispatch]=useReducer(storeReducer,{
        // showMovies:true,
        // showTv:false,
       
        stack:[],
    });

    const [productState,productDispatch]=useReducer(productReducer,{
        byRating:0,
        sort:false,
    })
    
    return (
        <GlobalData.Provider value={{clickedId,setClickedId,state,dispatch,productState,productDispatch,sorted,setSorted,allData,setAllData,textSearch,settextSearch}}>
         {children}
        </GlobalData.Provider>
    )
}

export const GlobalDataState=()=>{
    return useContext(GlobalData);
}
export default Context